import axios from "axios";
import { useLoader } from "../context/LoaderProvider";

const API_KEY = process.env.REACT_APP_TRANSLATE_API_KEY;
const GOOGLE_API = process.env.REACT_APP_TROCR;

const API_URL = `${GOOGLE_API}?key=${API_KEY}`;


export const transliterateText = async (textArray, targetLang) => {
  try {
    const { data } = await axios.post(API_URL, {
      q: textArray,
      target: targetLang,
      format: "text",
      model: "base" // base = simple conversion, no semantic meaning
    });
    return data?.data?.translations.map(t => t.translatedText);
  } catch (err) {
    console.error("Transliteration Error:", err);
    return textArray;
  }
};

